export default {
  GET_APPROXIMATE_VALUES_QUERY_SERVICE: Symbol.for('GET_APPROXIMATE_VALUES_QUERY_SERVICE'),
  APPROXIMATE_VALUE_REPOSITORY: Symbol.for('APPROXIMATE_VALUE_REPOSITORY'),
  APPROXIMATE_VALUE_STATE_MANAGER: Symbol.for('APPROXIMATE_VALUE_STATE_MANAGER'),
};
